export const benefits = [
  {
    id: 1,
    title: "Contenido de Calidad Privado",
    description: "Vas a ver contenido de altísima calidad que no está a nivel público, solo lingotes de oro en cada video.",
    icon: "💎"
  },
  {
    id: 2,
    title: "Comunidad Organizada",
    description: "La comunidad tiene muchos canales bien definidos, revísalos todos para familiarizarte.",
    icon: "📋"
  },
  {
    id: 3,
    title: "Comunidad global",
    description: "Tienes un lugar para poder interactuar con traders de todo el mundo.",
    icon: "🌎"
  },
  {
    id: 4,
    title: "Merchandising NSL",
    description: "Tienes acceso de pre-venta de Gorras, Hoodies, Camisetas y demás items de NSL.",
    icon: "👕"
  }
];